import { Fragment, useEffect, useState } from "react";
import { User } from "../../models/User";
import { Group } from "../../models/Group";
import { isEmpty, first, map, replace } from 'lodash'
import { Organization } from "../../models/Organization";
import { NoContentWrapper, getTrendClass, renderPeriod } from "../../helpers/renderHelper";
import { Dropdown, Stack } from "react-bootstrap";
import { useLazyQuery } from "@apollo/client";
import { GET_USERS, GET_GROUPS } from "../../graphQL/queries";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { setGroup, setUsers } from "../../redux/appStateSlice";
import DriverCard from "../common/DriverCard";
import LoadingSpinner from "../common/LoadingSpinner";
import { Paths } from "../routes/Routes";
import { useNavigate } from "react-router";
import { buildGroupDrivers } from '../../helpers/managerHelper';
import { clearBackNavigation, setSelectedGroup } from "../../redux/navigationSlice";
import { AppMessages } from '../../strings';

const ManagerSummary = ({currentUser, currentOrganization, allGroups}:{currentUser?: User, currentOrganization?:Organization, allGroups?:Group[]}) => {

	const dispatch = useAppDispatch();
	const navigate = useNavigate()

	const userGroups = useAppSelector(state => state.appState.groupUsers)
	const currentSelectedGroup = useAppSelector(state => state.nav.currentSelectedGroup)
	const [hasFetchedGroup, setHasFetchedGroup] = useState(false)
	const [hasFetchedDrivers, setHasFetchedDrivers] = useState(false)

	const [getDrivers, getDriversResponses ] = useLazyQuery(GET_USERS, 
		{ variables: { 
			groupID: currentSelectedGroup?.groupID ?? -1, 
			onlyDrivers: true,
			startDate: process.env.REACT_APP_MANAGER_START_DATE ? process.env.REACT_APP_MANAGER_START_DATE : null ,
			endDate: process.env.REACT_APP_MANAGER_END_DATE ? process.env.REACT_APP_MANAGER_END_DATE : null,
			prevStartDate: process.env.REACT_APP_MANAGER_PREV_START_DATE ? process.env.REACT_APP_MANAGER_PREV_START_DATE : null,
			prevEndDate: process.env.REACT_APP_MANAGER_PREV_END_DATE ? process.env.REACT_APP_MANAGER_PREV_END_DATE : null
		} 
	});

	const [getGroup, getGroupResponses ] = useLazyQuery(GET_GROUPS, 
		{ variables: { 
			groupID: currentSelectedGroup?.groupID, 
			isLocationGroup: true,
			hasDrivers: true,
			startDate: process.env.REACT_APP_MANAGER_START_DATE ? process.env.REACT_APP_MANAGER_START_DATE : null ,
			endDate: process.env.REACT_APP_MANAGER_END_DATE ? process.env.REACT_APP_MANAGER_END_DATE : null,
			prevStartDate: process.env.REACT_APP_MANAGER_PREV_START_DATE ? process.env.REACT_APP_MANAGER_PREV_START_DATE : null,
			prevEndDate: process.env.REACT_APP_MANAGER_PREV_END_DATE ? process.env.REACT_APP_MANAGER_PREV_END_DATE : null
		} 
	});
		
	const allDrivers = currentSelectedGroup ? userGroups[currentSelectedGroup.groupID]?.users : []
	const drivers = buildGroupDrivers(allDrivers);
	const hasData = hasFetchedGroup && hasFetchedDrivers

	useEffect(()=>{
		dispatch(clearBackNavigation())
	},[])

	// Call build
	useEffect(()=>{
		if (currentUser && allGroups) {
			if (!isEmpty(allGroups) && !currentSelectedGroup) {
				setCurrentSelectedGroup(first(allGroups));
			}
		}
	}, [currentUser, allGroups]);

	useEffect(()=>{
		if (currentSelectedGroup && currentUser) {
			getGroup();
			if (currentSelectedGroup?.groupID !== -1 && currentUser?.isInDriverRole === false) {
				getDrivers()
			}
		}		
	}, [currentSelectedGroup, currentUser])

	useEffect(()=>{
		if (getDriversResponses?.data) {
			dispatch(setUsers({groupId: currentSelectedGroup?.groupID ?? -1, groupUsers:getDriversResponses?.data}))

			setHasFetchedDrivers(true);
		}
	},[getDriversResponses?.data])

	useEffect(()=>{
		if (getGroupResponses?.data?.groups) {
			dispatch(setGroup(first(getGroupResponses?.data.groups)));

			setHasFetchedGroup(true);
		}
	},[getGroupResponses?.data])


	function setCurrentSelectedGroup(group: Group) {

		setHasFetchedGroup(false);
		setHasFetchedDrivers(false);

		dispatch(setSelectedGroup(group))
	}

	function navigateToDetails(e, user) {
		e.stopPropagation();

		const path = replace(Paths.MANAGER_DRIVER_DETAIL, ':id', user?.userID).replace(':groupid', currentSelectedGroup?.groupID);
		navigate(path);
	}

	function renderGroupScore() { 
		const scorecard = first(currentSelectedGroup?.scorecard)
		const trendClass = getTrendClass(scorecard?.trend, "")

		var title = "Average Score"
		if(!scorecard?.avgCurrentScore) {
			title = "No Score"
		}

		return (
			<div className="row" >
					<div className="col-12">
						<div className="card" style={{padding: '0.35rem'}}>
							<div style={{color:'white', backgroundColor:'#212121', borderRadius:'0.25rem'}}>
								<Stack direction="horizontal" style={{ height:'50px', paddingLeft:2}}>
									<div className="col col-6 g-0 p-2 mb-0 fs-5" style={{textAlign: "left" }}>{title}</div>
									<div className="col col-6 fw-bold" style={{ textAlign: "right"}}>
										<Stack direction="horizontal" style={{float:'right'}}>
											<div style={{fontSize:'40px'}}>{`${scorecard?.avgCurrentScore ?? ""} `}</div>
											<i style={{fontSize:'30px', marginLeft:5, marginRight: 10}} className={trendClass} />
										</Stack>
									</div>
								</Stack>

							</div>
						</div>
					</div>
				</div>
		)
	}

	return (
		<Fragment>
			{ getDriversResponses.loading && <LoadingSpinner title="drivers"/>}
			<div className="container" style={{marginTop:0, color:'white'}}>
				{renderPeriod(currentOrganization)}	
				<div className="row">
					<div className="col-12 align-items-center" >
						<div className="card" style={{marginBottom: "0.35rem"}}>
							<div className="card-body align-items-center" style={{padding: "0.15rem"}}>
								<Dropdown>
									<Dropdown.Toggle className="btn btn-secondary btn-lg dropdown-toggle w-100 fw-normal" id="dropdownMenuButtonLG">
										{currentSelectedGroup?.name}
									</Dropdown.Toggle>
									<Dropdown.Menu>
										{
											map(allGroups, (g, index) => {
												return <Dropdown.Item key={`group-key-154-${index}`} href="#" onClick={e => setCurrentSelectedGroup(g)}>{g.name}</Dropdown.Item>
											})
										}
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</div>
					</div>
				</div>
				{ renderGroupScore() }
				<div className="row"  style={{color:'white'}}>
					<div className="col-12">
						<div className="card" style={{marginBottom: "0.35rem !important"}}>
							<div className="card-body align-items-center" style={{padding: "0.35rem"}}>
								<div className="row g-0 p-0">
									<NoContentWrapper items={drivers} message={hasData ? first(currentSelectedGroup?.scorecard)?.avgCurrentScore ? AppMessages.noOffendingDrivers : AppMessages.noOrganizationScore : ""} showIcon={(first(currentSelectedGroup?.scorecard)?.avgCurrentScore && hasData) ? true : false}>
										{ map(drivers,(d,i) => {
											return <DriverCard key={`driver-553-${i}`} isFirst={true} isSummary={true} user={ d } onClick={ e => navigateToDetails(e, d)}/>
										})}
									</NoContentWrapper>

								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Fragment>
	)
}

export default ManagerSummary;